import Join from './join';
import Manage from './manage';
import Check from './check';
import ActivityReceipt from './activity-receipt';
import ManagerPending from '@/pages/activity-manage/merchants/venue-detail/micro-app-pages/manager-pending';

// 判断是待审核管理
export function routeItemIsCheck({ title, path }) {
  if (title === '待审核管理' && path.endsWith('/check')) return true;
  return false;
}

export default [
  /* Remark：业务发展需要，上面两个close，合并成现在的一个``会场收品：`ActivityReceipt```----start */
  {
    title: '会场活动',
    path: '/activityReceipt',
    component: ActivityReceipt,
    businessId: 10013,
  },
  /* Remark：业务发展需要，上面两个close，合并成现在的一个```会场收品：ActivityReceipt```----end */
  // TODO:按照新的产品规划，先放开适配老的通天塔过来的，等这边管理页面的弹窗好了，就不需要了，再关掉
  // activityReceipt建设完毕，老的不要了，替换成新的
  {
    title: '可参与的活动',
    path: '/join',
    component: Join,
    businessId: 10013,
    hideInNav: true,
  },
  // activityReceipt建设完毕，老的不要了，替换成新的
  {
    title: '我管理的活动',
    path: '/manage',
    component: Manage,
    businessId: 10014,
    hideInNav: true,
  },
  {
    title: '待审核管理',
    path: '/check',
    component: Check,
    businessId: 10015,
    getLink({ parentPath, search, path }) {
      return path + '?tab=2';
    },
  },
  {
    title: '视觉审核管理',
    path: '/managerpending',
    component: ManagerPending,
    businessId: 10016,
    getLink({ parentPath, search, path }) {
      return path + '?tab=1';
    },
  },
];
